import React, { FC, Fragment, useRef } from "react";
import useNavModulesAndItsActions from "../hooks/useNavModulesAndItsActions";
import * as S from "../styles";
import Modules, { ModulesProps } from "./ModulesList";

const DesktopModules: FC<ModulesProps> = ({ moduleIds, closeNav }) => {
  const navDivRef = useRef<HTMLDivElement>(null);

  const {
    visibleModuleIds,
    visibleLeftArrow,
    visibleRightArrow,
    leftArrowAction,
    rightArrowAction,
  } = useNavModulesAndItsActions(moduleIds, navDivRef);

  return (
    <Fragment>
      <S.HiddenModulesDiv ref={navDivRef}>
        <Modules moduleIds={moduleIds} closeNav={closeNav} />
      </S.HiddenModulesDiv>
      <S.ModulesNavContainer
        data-cy="modules-nav-container"
        id="tour-nav-bar-item"
      >
        <S.LeftArrow isVisible={visibleLeftArrow} onClick={leftArrowAction} />
        <Modules moduleIds={visibleModuleIds} closeNav={closeNav} />
        <S.RightArrow
          data-cy="right-arrow-modules"
          isVisible={visibleRightArrow}
          onClick={rightArrowAction}
        />
      </S.ModulesNavContainer>
    </Fragment>
  );
};

export default DesktopModules;
